import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlCreationOptions } from '@angular/router';
import { LoginService, TermsOfUseService } from '@pxl/models/contracts';

export const acceptedTosGuard = (expectedState: boolean, redirectTo: any[]): CanActivateFn => {
    return async (_activatedRoute, routerState) => {
        const loginService = inject(LoginService);
        const tosService = inject(TermsOfUseService);
        const router = inject(Router);
        const isLoggedIn = await loginService.isLoggedIn();

        if (!isLoggedIn) return false;

        try {
            const userTermsOfUse = await tosService.getUserTermsOfUse();
            const tosState = userTermsOfUse.isEulaValid && userTermsOfUse.isPrivacyPolicyValid;

            if (tosState !== expectedState) {
                const navigationExtras: UrlCreationOptions = expectedState ? { queryParams: { destinationUrl: routerState.url } } : {};
                return router.createUrlTree(redirectTo, navigationExtras);
            }
            return true;
        } catch {
            await loginService.logoutUser(false, true);
            return false;
        }
    };
};
